import React from 'react'

const PageNotFound = () => {
  return (
    <>
      <div className="flex justify-center items-center h-screen">
        <h1 className="font-bold">Page you are looking for does not exist! 404</h1>
      </div>
    </>
  )
}

export default PageNotFound;